import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

// Users screen shows its own Snackbar → opt mutations out of the global duplicate
// SUCCESS toast; keep global ERROR as the safety net.
const SN = { skipNotify: 'success' };

export const fetchUsers = createAsyncThunk(
  'user/fetchUsers',
  async ({ page = 1, limit = 25, search = '', role = '', status = '', isVerified = '' }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/admin/users', {
        params: { 
          page, 
          limit, 
          search: search || undefined, 
          role: role || undefined, 
          status: status || undefined, 
          isVerified: isVerified !== '' ? isVerified : undefined 
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || 'Failed to fetch users'
      );
    }
  }
);

export const addUser = createAsyncThunk(
  'user/addUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/admin/users', userData, SN);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || 'Failed to add user'
      );
    }
  }
);

export const updateUserStatus = createAsyncThunk(
  'user/updateUserStatus',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/admin/users/${id}/status`, data, SN);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || 'Failed to update user status'
      );
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  'user/updateUserDetails',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/admin/users/${id}`, data, SN);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || 'Failed to update user details'
      );
    }
  }
);

export const deleteUser = createAsyncThunk(
  'user/deleteUser',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/admin/users/${id}`, SN);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || 'Failed to delete user'
      );
    }
  }
);

const initialState = {
  users: [],
  totalUsers: 0,
  currentPage: 1,
  totalPages: 0,
  isLoading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload.users;
        state.totalUsers = action.payload.totalUsers;
        state.currentPage = action.payload.currentPage;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
